import {UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {RoutingService} from 'src/app/services/routing.service';
import {Title} from '@angular/platform-browser';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {finalize} from 'rxjs/operators';
import {Subscription} from 'rxjs';

import {TerraUtils} from '../../shared/TerraUtils';
import {UserService} from 'src/app/services/shared/user.service';
import {PasswordValidator} from 'src/app/shared/validators/password.validators';
import {ConfirmPasswordStateMatcher} from 'src/app/shared/validators/confirmPasswordStateMatcher';
import { AppSettingsService, SubdomainEnum } from 'src/app/services/app-settings.service';

@Component({
  selector: 'terra-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  paths = TerraUtils.consts.paths;
  isLoading = false;
  paramsSubscription: Subscription;

  token: string;

  passwordFormGroup: UntypedFormGroup;
  passwordFormGroupSubmitted = false;

  matcher = new ConfirmPasswordStateMatcher();
  generalError = '';

  referrerLogo$ = this.appSettingsService.subDomain === SubdomainEnum.GP ? this.userService.gp_referrerLogo$ : this.userService.lp_referrerLogo$;

  constructor(
    private formsBuilder: UntypedFormBuilder,
    private userService: UserService,
    private route: ActivatedRoute,
    private titleService: Title,
    public routingService: RoutingService,
    public appSettingsService:AppSettingsService
  ) {
    this.passwordFormGroup = new UntypedFormGroup(
      {
        password: new UntypedFormControl(null, [
          Validators.required,
          Validators.minLength(8),
          PasswordValidator.PasswordStrength
        ]),
        confirmPassword: new UntypedFormControl(null, [
          Validators.required
        ])
      },
      {
        validators: [PasswordValidator.MatchPassword]
      }
    );
  }

  ngOnInit() {
    // https://help.luckyorange.com/article/140-preventing-transmission-of-sensitive-data
    // don't send sensitive info to luckyorange
    // window['__lo_disable_dynamic_mode'] = true;

    this.titleService.setTitle('Reset Password');
    this.paramsSubscription = this.route.params.subscribe(params => {
      this.token = params.token;
    });
  }

  public resetPassword() {
    this.passwordFormGroupSubmitted = false;
    this.generalError = '';

    if (this.isLoading) {
      return;
    }

    if (this.passwordFormGroup.invalid) {
      this.passwordFormGroup.get('password').markAsTouched();
      this.passwordFormGroup.get('confirmPassword').markAsTouched();
      return;
    }
    this.isLoading = true;

    this.userService.resetPassword(
      this.token,
      this.passwordFormGroup.get('password').value,
      this.passwordFormGroup.get('confirmPassword').value
    ).pipe(
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe(
      result => {
        this.passwordFormGroupSubmitted = true;
        this.passwordFormGroup.reset();
      },
      err => {
        this.passwordFormGroup.reset();
        this.passwordFormGroup.get('confirmPassword').setErrors({badrequest: true});
        this.generalError = `The reset link has expired.`;
      }
    );
  }
}
